import paths from '@app/src/wf-constants/paths'
import { LocalLibrary, LocalLibraryOutlined } from '@mui/icons-material'
import React from 'react'
import { useIntl } from 'react-intl'
import NavigationMenuItem from '../VerticalMenu/NavigationItems/NavigationMenuItem'

const SustainabilityLibraryMenuItem: React.FC = () => {
  const { formatMessage } = useIntl()

  return (
    <NavigationMenuItem
      path={paths.sustainabilityLibrary}
      title={formatMessage({ id: 'configurations.sustainabilityLibrary' })}
      icon={LocalLibraryOutlined}
      iconSelected={LocalLibrary}
    />
  )
}

export default SustainabilityLibraryMenuItem
